/**
 * PaymentQR i18n exports
 */
import { paymentQRTranslations as en } from './en';
import { paymentQRTranslationsPl as pl } from './pl';

export const translations = {
  en,
  pl,
};

export type SupportedLocale = keyof typeof translations;

/**
 * Get translations for a given locale
 */
export const getTranslations = (locale: SupportedLocale = 'en') => {
  return translations[locale] || translations.en;
};

/**
 * Simple template string interpolation
 * Usage: interpolate('Hello {name}!', { name: 'World' }) => 'Hello World!'
 */
export const interpolate = (
  template: string,
  values: Record<string, string | number>
): string => {
  return template.replace(/{(\w+)}/g, (_, key) => String(values[key] ?? `{${key}}`));
};

export { en };
